export default {
    message: "Onderstaande artikelen zijn niet op voorraad en zijn verwijderd uit uw winkelwagen. Maak verschillende keuzes.",
    buttons: {
        ok: "OK"
    }
}